import React from 'react'
import cx from 'classnames'

import Box from './box'

const FormField = ({
  className,
  ...props
}) => {
  const classes = cx('m-form-field', className)

  return (
    <Box className={classes} {...props} />
  )
}

export default FormField
